module.exports = __webpack_public_path__ + "img/done.59ac5b0e.svg";